import React, { useEffect, useState } from 'react'
import { Modal, notification } from 'antd';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axiosInstance from '../../../../Services/axiosCommon';
import { NuInput } from '../../../../Components/Utils/Input';
import Attachement, { videotype } from '../../../../Components/Utils/CustomAttrachmentupload';
import CloseIcon from '../../../../Components/Icons/Close';
import Video from '../../../../Components/Icons/Video';
import Doc from '../../../../Components/Icons/Doc';
import Xls from '../../../../Components/Icons/Xls';
import Txt from '../../../../Components/Icons/Txt';
import Pdf from '../../../../Components/Icons/Pdf';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';
import { useToast } from '../../../../Components/Others/ToastServices';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';

const EditEquipmentEqu = ({ open, getData = () => {}, onCancel, data, id }) => {
  const [api, contextHolder] = notification.useNotification();
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [fileRemoveList, setFileRemoveList] = useState([]);
  const [image, setImage] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileExtention, setFileExtention] = useState("");
  const toast = useToast();
 const { value: type,getData:reftype } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "type_equipments"
      );
  const [initialData, setInitialData] = useState({
    idNumber: "",
    type: "",
    location: "",
    qrCode: ""
  });

  useEffect(() => {
    if (data) {
      setInitialData({
        idNumber: data.idNumber || "",
        type: data.type || "",
        location: data.location || "",
        qrCode: data.qrCode || ""
      });

      if (data?.equipmentImage && data?.equipmentImage !== "None" && data?.equipmentImage !== "[]") {
        setFilePathList(data?.equipmentImage);
      }
    }
  }, [data]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialData,
    validationSchema: yup.object({
      idNumber: yup.string().required("ID Number is required"),
      type: yup.string().required("Type is required"),
      location: yup.string().required("Location is required"),
      qrCode: yup.string().required("QR Code is required")
    }),
    onSubmit: (value, { resetForm }) => {
      // let formData = new FormData();
      // const valueWithFiles = {
      //   ...value,
      //   filesToRemove: fileRemoveList
      // };
      // formData.append("json_data", JSON.stringify(valueWithFiles));

      // if (selectedFile !== null) {
      //   selectedFile.forEach((file) => {
      //     formData.append("attachments", file);
      //   });
      // } else {
      //   formData.append("attachments", []);
      // }

      axiosInstance
        .put(`/equipment-details/update/${data?.id}`, value, resetForm)
        .then((res) => {
          if (res.data.status) {
            api.success({
              message: `Equipment updated successfully`,
              description: res?.data?.msg || "Updated equipment",
              placement: "bottomRight",
            });
            getData(id);
            resetForm();
            onCancel();
          } else {
            api.error({
              message: `Update failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Update failed`,
            description: err?.data?.msg || "Server error or Network error",
            placement: "bottomRight",
          });
        });
    }
  });

  function handleImageChange(e) {
    const maxFileSize = 200000000;
    const files = Array.from(e.target.files);
    let fileArr = [];
    let tempArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {
        fileArr.push(item);
        tempArr.push(item?.name);
      } else {
        toast.open({
          type: "warning",
          message: `File too big`,
          description: `${item.name} was removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);
    setImage(tempArr);
  }

  function UpdateAttachmentList(file) {
    let filtered = filePathList.filter((f) => f.file !== file);
    let removed = filePathList.find((f) => f.file === file);
    setFileRemoveList([...fileRemoveList, removed.file]);
    setFilePathList(filtered);
  }

  function handleImageClick(img) {
    let Ext = img?.file_name.split(".").reverse()[0];
    setSelectedImage(img);
    setFileExtention(Ext);
  }

  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title="Edit Equipment"
        width="50%"
        className="perfect-centered-modal"
        centered
        onCancel={onCancel}
        footer={null}
        styles={{
          body: { maxHeight: '70vh', overflowY: 'auto', padding: '4px' }
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full flex flex-wrap gap-4">
            <NuInput label="ID Number" name="idNumber" formik={formik} placeholder="Enter ID" width="w-full" />
            {/* <NuInput label="Type" name="type" formik={formik} placeholder="Enter type" width="w-full" /> */}
             <FormikSelectTwo
                                           label="Type"
                                           Options={type}
                                           formik={formik}
                                           placeholder="Choose"
                                           name="type"
                                          
                                           width="w-full  "
                                         /><NuInput label="Location" name="location" formik={formik} placeholder="Enter location" width="w-full" />
            <NuInput label="QR Code" name="qrCode" formik={formik} placeholder="Enter QR code" width="w-full" />

            {/* <div className="w-full">
              <SettingHeading title="Attachments :" />
            </div>

            <div className="flex flex-wrap gap-2 w-full">
              {filePathList?.map((imgs, idx) => {
                let Ext = imgs?.file_name.split(".").reverse()[0];
                return (
                  <div
                    key={idx}
                    className="w-20 h-9 my-2 relative flex justify-center items-center rounded-lg border border-slate-400"
                  >
                    <div
                      className="w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer flex justify-center items-center -top-2 -right-2"
                      onClick={() => UpdateAttachmentList(imgs?.file)}
                    >
                      <CloseIcon color="white" height="8" width="8" />
                    </div>
                    <div
                      className="w-20 h-9 flex justify-center items-center cursor-pointer overflow-hidden"
                      onClick={() => handleImageClick(imgs)}
                    >
                      <div className="w-8 h-8">
                        {videotype.includes(Ext) ? <Video /> :
                          Ext === "docx" || Ext === "doc" ? <Doc /> :
                          Ext === "xlsx" || Ext === "xls" ? <Xls /> :
                          Ext === "txt" ? <Txt /> :
                          Ext === "pdf" || Ext === "PDF" ? <Pdf /> :
                          <img src={imgs?.file} alt="#" width="120%" />}
                      </div>
                      <p className="w-[50px] text-[11px] truncate">{imgs?.file_name}</p>
                    </div>
                  </div>
                );
              })}

              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full md:w-1/2"
                label="Attach"
                multiple={true}
              />
            </div> */}

            <button type="submit" className="w-11/12 bg-baseColor-primary py-3 rounded-lg text-sm text-white mx-auto">
              Update
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default EditEquipmentEqu;
